/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import * as _ from 'lodash';

@Component({
  selector: 'time-out',
  template: require('./time-out.component.html')
})
export class TimeOutComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
  }

  btnClick() {
    this.flowManager.refreshApp();
  }
}
